const _parseBold = text => text.replace(/\*([^*]*)\*/g, x => `<strong>${x.substring(1, x.length - 1)}</strong>`);
const _parseItalic = text => text.replace(/\\([^\\]*)\\/g, x => `<em>${x.substring(1, x.length - 1)}</em>`);
const _parseUnderline = text => text.replace(/_([^_]*)_/g, x => `<u>${x.substring(1, x.length - 1)}</u>`);
const _stripIcons = text => text.replace(/(:[a-z/-]*?:)/g, '');

const _stripIconGroup = text =>
	text.replace(/!--ICON-GROUP--!(.*?)!--ICON-GROUP--!/g, (x, p1) => p1.replace(/:(.*?):/g, ''));

const _parseLink = text => {
	const matchRegex = /\[([^[\]]+)\]\(([^()]+)\)/g;
	return text.replace(matchRegex, x => {
		const regexValue = matchRegex.exec(x);
		const linkText = regexValue?.[1];
		const href = regexValue?.[2];

		// reset the regex
		matchRegex.lastIndex = 0;

		// Check if there is a valid URL found. If so, use the first match (The url) href[0].
		if (href) {
			return `<a href="${href}" rel="noopener noreferrer" target="_blank">${linkText}</a>`;
		}

		return text;
	});
};

const _parseGynzyScreenshot = text => {
	const screenshotRegex =
		/!\[(.*?)\]\(gynzy-screenshot:\/\/([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})#([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})\)/g;

	return text.replace(screenshotRegex, x => {
		const regexValue = screenshotRegex.exec(x);
		const [, alt, lessonId, pageId] = regexValue;

		// reset the regex
		screenshotRegex.lastIndex = 0;

		if (lessonId && pageId) {
			const thumbnailURL = `https://storage.googleapis.com/lesson-thumbnails/${lessonId}/${pageId}/high.jpeg`;
			return `<img alt="${alt}" src="${thumbnailURL}" style="width: 28rem"/>`;
		}

		return text;
	});
};

export const parseLongDescription = text => {
	const parsed = [];
	let nextSliceIndex = 0;

	if (text) {
		text.replace(
			/!---([+]?)(.+)\n([^]+?)\n---!\n?/g,
			(
				match, // original string to match on
				expandedByDefault, // group 1 of regex, matches the '+' sign
				title, // group 2
				description, // group 3
				offset // The offset of the matched substring within the whole string being examined. (For example, if the whole string was 'abcd', and the matched substring was 'bc', then this argument will be 1.)
			) => {
				// slice get the text before the match
				// const sliced = text.slice(nextSliceIndex, offset);
				nextSliceIndex = offset + match.length;

				let text = _parseGynzyScreenshot(description);
				text = _parseLink(text);
				text = text.replace(/\n/g, '<br>');
				text = _parseBold(text);
				text = _parseItalic(text);
				text = _parseUnderline(text);
				text = _stripIconGroup(text);

				parsed.push({
					title: _stripIcons(title),
					description: text,
				});
			}
		);

		// There is possibly text 'behind/after' the last match. Add this to our array.
		const sliced = text.slice(nextSliceIndex, text.length);
		const noToggleText = sliced;
		if (noToggleText !== '') {
			parsed.push(noToggleText);
		}
	}

	return parsed;
};
